import React, { useState } from 'react';
import { ChevronDown, ChevronUp, Package, Percent } from 'lucide-react';
import { bundles } from '../data/mock';

const BundlesSection = () => {
  const [expandedBundles, setExpandedBundles] = useState({});

  const toggleBundle = (bundleId) => {
    setExpandedBundles(prev => ({
      ...prev,
      [bundleId]: !prev[bundleId]
    }));
  };

  return (
    <section className="py-20 bg-white">
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="heading-large text-gray-900 mb-4">
            Bundles
          </h2>
          <p className="body-large text-gray-600 max-w-2xl mx-auto">
            Get more for less with our course bundles
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {bundles.map((bundle) => (
            <div key={bundle.id} className="bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 hover-lift overflow-hidden flex flex-col h-full">
              <div className="relative">
                <img 
                  src={bundle.image} 
                  alt={bundle.title}
                  className="w-full h-40 object-cover bg-gray-50"
                />
                <div className="absolute top-4 right-4 bg-green-500 text-white px-3 py-1 rounded-full text-sm font-medium">
                  Save {Math.round((bundle.savings / bundle.originalPrice) * 100)}%
                </div>
              </div>
              
              <div className="p-6 flex flex-col flex-grow">
                <div className="flex items-start gap-3 mb-4">
                  <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <Package className="text-purple-600" size={20} />
                  </div>
                  <div>
                    <h3 className="heading-medium text-gray-900 mb-1">
                      {bundle.title}
                    </h3>
                    <p className="body-small text-gray-600">
                      {bundle.description}
                    </p>
                  </div>
                </div>

                <div className="mb-4 flex-grow">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="text-lg text-gray-500 line-through">
                      ${bundle.originalPrice}
                    </span>
                    <span className="text-3xl font-bold text-gray-900">
                      ${bundle.discountedPrice}
                    </span>
                  </div>
                </div>

                {/* Expandable Course List */}
                <div className="mb-4">
                  <button
                    onClick={() => toggleBundle(bundle.id)}
                    className="w-full flex items-center justify-between text-left text-purple-600 hover:text-purple-700 font-medium"
                  >
                    <span>View included courses</span>
                    {expandedBundles[bundle.id] ? 
                      <ChevronUp size={20} /> : 
                      <ChevronDown size={20} />
                    }
                  </button>
                  
                  {expandedBundles[bundle.id] && (
                    <div className="mt-3 pl-4 border-l-2 border-purple-100">
                      <ul className="space-y-2">
                        {bundle.courses.map((course, index) => (
                          <li key={index} className="body-small text-gray-600 flex items-center gap-2">
                            <div className="w-1.5 h-1.5 bg-purple-400 rounded-full"></div>
                            {course}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>

                <button 
                  className="btn-outline-gradient w-full justify-center mt-auto"
                  onClick={() => {
                    const bundleRoutes = {
                      1: "/bundles/aws-projects-bundle",
                      2: "/bundles/all-in-one-bundle", 
                      3: "/bundles/cloud-newbie-bundle",
                      4: "/bundles/ultimate-projects-bundle"
                    };
                    
                    const route = bundleRoutes[bundle.id];
                    if (route) {
                      window.location.href = route;
                    }
                  }}
                >
                  More Details
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Special Offer Banner */}
        <div className="mt-16 bg-gradient-to-r from-purple-600 via-blue-600 to-indigo-600 rounded-xl p-8 text-center text-white shadow-lg">
          <h3 className="heading-medium mb-2 font-bold">
            🎁 Special Offer!
          </h3>
          <p className="body-large mb-4 opacity-95">
            Get 20% off any course or bundle - Start your cloud journey today!
          </p>
          <p className="body-small opacity-85 font-medium">
            Use code: OFFER20 at checkout
          </p>
        </div>
      </div>
    </section>
  );
};

export default BundlesSection;